import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import FiberNewIcon from "@mui/icons-material/FiberNew";
import FileCopyIcon from "@mui/icons-material/FileCopy";
import CategoryIcon from "@mui/icons-material/Category";
import SummarizeIcon from "@mui/icons-material/Summarize";
import QuizIcon from "@mui/icons-material/Quiz";
import FactCheckIcon from "@mui/icons-material/FactCheck";
import AirportShuttleIcon from "@mui/icons-material/AirportShuttle";
import ChangeCircleIcon from "@mui/icons-material/ChangeCircle";
import { openUserManual } from "../common";

// Add menu items here to be displayed in responsive menu bar
export const menuItems = [
  {
    title: "All Users",
    route: "/users",
    access: ["admin"],
    icon: <PeopleAltIcon />,
  },
  {
    title: "All Suppliers",
    route: "/supplierList",
    access: ["admin"],
    icon: <AirportShuttleIcon />,
  },
  {
    title: "New Request",
    route: "/addRequest",
    access: ["procurement", "chef", "executiveChef"],
    icon: <FiberNewIcon />,
  },
  {
    title: "Sample Requests",
    route: "/sampleRequests",
    access: [
      "sampleControl",
      "sampleControlView",
      "procurement",
      "chef",
      "executiveChef",
      "hod",
    ],
    icon: <FileCopyIcon />,
  },
  {
    title: "All Items",
    route: "/allItems",
    access: ["executiveChef", "hod", "chef"],
    icon: <CategoryIcon />,
  },
  {
    title: "All Items",
    route: "/",
    access: ["sampleControl", "sampleControlView", "procurement"],
    icon: <CategoryIcon />,
  },
  {
    title: "Bulk Approval",
    route: "/",
    access: ["executiveChef", "hod", "chef"],
    icon: <FactCheckIcon />,
  },
  {
    title: "Delegate Approver",
    route: "/delegateApprover",
    access: ["chef", "procurement"],
    icon: <ChangeCircleIcon />,
  },
  {
    title: "Quality Reports",
    route: "/qualityReports",
    access: [
      "sampleControl",
      "sampleControlView",
      "procurement",
      "hod",
      "chef",
      "executiveChef",
    ],
    icon: <SummarizeIcon />,
  },
  {
    title: "User Manual",
    action: openUserManual,
    access: [
      "sampleControl",
      "sampleControlView",
      "procurement",
      "hod",
      "chef",
      "executiveChef",
    ],
    icon: <QuizIcon />,
  },
];
